module.exports = __webpack_public_path__ + "static/media/pause-button.595ed125.png";